module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'login-page': _vm.isLoginPage
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.isLoginPage) ? [_c('router-view')] : [_c('mycard', {
    staticClass: "sidebar"
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('router-view')], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28f13716"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 429
// module chunks = 3